import { toast } from "react-toastify";
import { Toastify } from "../../../components/tostify/RenderToastify";
import api from "../../../utils/useApi";
import BasketGenerateReference from "./Basket.GenerateReference";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { FunctionUploadFileAws } from "../../../utils/useFunction";
import { checkTime } from "../render/Busket.ModalDateTime";

const ERROR_MESSAGE_ADDRESS = {
  EN: "Please select address.",
  TH: "กรุณาเลือกที่อยู่",
};

const ERROR_MESSAGE_DATE = {
  EN: "Please select date.",
  TH: "กรุณาเลือกวันที่",
};

const ERROR_MESSAGE_PROGRAM = {
  EN: "Please select program.",
  TH: "กรุณาเลือกบริการ",
};

const ERROR_MESSAGE_DELAY_DATE = {
  EN: "Date or time is not available now.Please select again.",
  TH: "วันที่หรือเวลาไม่สามารถใช้งานได้ในขณะนี้ กรุณาเลือกใหม่อีกครั้ง",
};

const BasketCheckErrorData = ({
  user,
  form,
  sameDayService,
  dateTime,
  address,
  addressDetail,
  refno,
  language,
}) => {
  const checkLocation = address?.location;
  const checkDate =
    dateTime?.pick_up_date?.date &&
    dateTime?.pick_up_time &&
    dateTime?.return_date?.date &&
    dateTime?.return_time;
  const checkPrograms = form?.programs?.programs?.length > 0;

  let isError = {
    error: false,
    message: "",
    where: "",
  };
  // const isError = Toastify;

  if (!checkLocation) {
    isError = {
      error: true,
      message: ERROR_MESSAGE_ADDRESS[language],
      where: "first-div-of-address",
    };
  }

  if (!checkDate) {
    isError = {
      error: true,
      message: ERROR_MESSAGE_DATE[language],
      where: "first-div-of-date-n-time",
    };
  }

  if (!checkPrograms) {
    isError = {
      error: true,
      message: ERROR_MESSAGE_PROGRAM[language],
      where: "first-div-of-programs",
    };
  }

  // if (checkTimeAgainPickUp) {
  //   isError = {
  //     error: true,
  //     message: ERROR_MESSAGE_DELAY_DATE[language],
  //     where: "first-div-of-date-n-time",
  //   };
  // }
  if (isError.error) {
    return isError;
  } else {
    return isError;
  }
};

const BasketPayment = async ({
  user,
  form,
  sameDayService,
  dateTime,
  address,
  addressDetail,
  refno,
  language,
  navigate,
  location,
  FunctionResetState,
  toast,
  sameDayServicePrice,
  setClicked,
  clicked,
  tellUsMore,
  tempDetailAddress,
  detailAddress,
}) => {
  if (clicked) {
    return;
  }
  try {
    setClicked(true);
    // if (!addressDetail) {
    //   toast.error("Please write your detail / กรุณาระบุรายละเอียด", {
    //     position: "top-center",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //   });
    //   setClicked(false);
    //   return;
    // }
    if (user?._id) {
      const isError = BasketCheckErrorData({
        user,
        form,
        sameDayService,
        dateTime,
        address,
        addressDetail,
        refno,
        language,
        location,
      });

      if (isError.error) {
        toast.error(isError.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setClicked(false);

        // document.getElementById(isError.where).scrollIntoView({
        //   behavior: "smooth",
        //   block: "center",
        // });
      } else {
        // const doc = new jsPDF("p", "px", [596, 843]);

        // const docElement = document.getElementById(`receipt-pdf`);

        // const canvas = await html2canvas(docElement, { scale: 2.5 });
        // const image = canvas.toDataURL("image/jpeg");
        // const pageWidth = doc.internal.pageSize.getWidth();
        // const pageHeight = doc.internal.pageSize.getHeight();

        // const widthRatio = pageWidth / canvas.width;
        // const heightRatio = pageHeight / canvas.height;
        // const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

        // const canvasWidth = canvas.width * ratio;
        // const canvasHeight = canvas.height * ratio;

        // const marginX = (pageWidth - canvasWidth) / 2;
        // const marginY = (pageHeight - canvasHeight) / 2;

        // doc.addImage(
        //   image,
        //   "JPEG",
        //   marginX,
        //   marginY,
        //   canvasWidth,
        //   canvasHeight
        // );
        // //   doc.save(`receipt-${new Date().getTime()}.pdf`);
        // const blobFile = doc.output("blob");

        // const file = new File([blobFile], `receipt-${refno}.pdf`, {
        //   type: "application/pdf",
        // });

        // const pdf_key = await FunctionUploadFileAws(file, false);

        // if (pdf_key) {

        const myAddress =
          user?.address?.length > 0
            ? user?.address?.find((row) => {
                return row?.place_id === address?.place_id;
              })?._id
            : false;

        if (myAddress && tempDetailAddress !== detailAddress) {
          await api.put(`/address/${myAddress}`, {
            detail: detailAddress,
          });
        }

        const response = await api.post("/payments", {
          refno: refno,
          full_name: user?.full_name,
          address: address,
          address_detail: tellUsMore ? addressDetail : "",
          phone_number: user?.phone_number,
          phone_code: user?.phone_code,
          email: user?.email,
          same_day_service: sameDayService,
          pickup_date: dateTime?.pick_up_date?.date,
          pickup_time: dateTime?.pick_up_time,
          return_date: dateTime?.return_date?.date,
          return_time: dateTime?.return_time,
          link: address?.link,
          special_request:
            form?.busket_program?.special_request_information || "",
          request: form?.busket_program?.special_request || false,
          water: form?.programs?.water || null,
          programs: form?.programs?.programs || null,
          cart: form?.cart,
          order_number: BasketGenerateReference(user),
          pdf_key: "out",
          same_day_service_price: sameDayServicePrice,
        });
        if (response.data.status === 200 && response.data) {
          document?.getElementById("button-submit")?.click();
        }
        if (response.data.status === 400) {
          toast.error(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setClicked(false);
        }
        // } else {
        // }
      }
    } else {
      sessionStorage.setItem("redirect", location.pathname);
      sessionStorage.setItem("payment", true);
      navigate("/Login");
    }
  } catch (error) {
    console.error("BasketPayment", error);
    setClicked(false);
  }
};

export default BasketPayment;
